// extracted by mini-css-extract-plugin
module.exports = {"SwitchTableViewBar":"SwitchTableViewBar","SwitchTableViewBar__item":"SwitchTableViewBar__item"};